import _ from 'lodash';

import { ALERT_DIALOG, CONFIRM_DIALOG, HIDE_DIALOG, SHOW_DIALOG, } from '../constants/dialogs';

export function showAlert(config) {
  return showDialog(ALERT_DIALOG, _.assign({
    title: 'Info',
    type: 'info',
  }, config));
}

export function showError(title, message, options) {
  console.log('showError', title, message, options);
  return showDialog(ALERT_DIALOG, _.assign({
    title: 'Error',
    type: 'error',
  }, {
    title,
    message,
  }, options));
}

export function showWarning(title, message, options) {
  return showDialog(ALERT_DIALOG, _.assign({
    title: 'Warning',
    type: 'warning',
  }, {
    title,
    message,
  }, options));
}

export function showInfo(title, message, options) {
  return showDialog(ALERT_DIALOG, _.assign({
    title: 'Info',
    type: 'info',
  }, {
    title,
    message,
  }, options));
}

export function showSuccess(title, message, options) {
  return showDialog(ALERT_DIALOG, _.assign({
    title: 'Success',
    type: 'success',
  }, {
    title,
    message,
  }, options));
}

export function showConfirm(config) {
  return showDialog(CONFIRM_DIALOG, _.assign({
    title: 'Success',
    type: 'warning',
    confirmButtonColor: 'red',
  }, config));
}

export function showDialog(name, context = {}) {
  return {
    type: SHOW_DIALOG,
    name,
    context,
  };
}

export function hideDialog(name) {
  return {
    type: HIDE_DIALOG,
    name,
  };
}

export function showSuccessSnack(title, text) {
//   toastr.success(title, text);
}

//
export function showInfoSnack(title, text) {
//   toastr.info(title, text);
}

//
export function showErrorSnack(title, text) {
//   toastr.error(title, text);
}



// WEBPACK FOOTER //
// ./src/redux/actions/dialogs.js